<template>
    <v-card>
        <v-card-title>
            <v-layout row wrap>
                <v-flex lg6 md6 xs12>
                    <p class="title">Client: {{visit.machine.client_location.client.name}}</p>
                </v-flex>
                <v-flex lg6 md6 xs12 v-if="visit.machine.client_location">
                    <p class="subheading"><b>Locatie client:</b> {{visit.machine.client_location.name}}</p>
                </v-flex>
                <v-flex lg6 md6 xs12>
                    <p><b>Data:</b> {{ filterDate(visit.created_at) }}</p>
                </v-flex>
                <v-flex lg6 md6 xs12>
                    <p><b>Stare:</b> {{this.$store.getters['visits/status'](visit.status).name}}</p>
                </v-flex>
                <v-flex lg6 md6 xs12>
                    <p><strong>Aparat:</strong> {{ visit.machine ? `${visit.machine.idstr} (${visit.machine.model.name})` : '' }}</p>
                </v-flex>
                <v-flex lg6 md6 xs12>
                    <p><b>Număr acțiuni:</b> {{ visit.total_actions }}</p>
                </v-flex>
            </v-layout>
        </v-card-title>
    </v-card>
</template>

<script>
import moment from 'moment';

export default {
  props: ['visit'],
  data() {
    return {

    };
  },

  methods: {
    filterDate(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    }
  }
};
</script>